export default __webpack_public_path__ + "static/media/actividad-1.e0a970c1.mp3";